/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapStateToProps = exports.name = exports.Summary = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'Summary';
exports.name = name;

var Summary = function Summary(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      List = _ref.List,
      ListItem = _ref.ListItem,
      ColorSquare = _ref.ColorSquare,
      styles = _ref.styles,
      theme = _ref.theme;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            _this$props$baseSpeci = _this$props.baseSpecifications,
            baseSpecifications = _this$props$baseSpeci === void 0 ? [] : _this$props$baseSpeci,
            before = _this$props.before,
            classes = _this$props.classes,
            _this$props$options = _this$props.options,
            options = _this$props$options === void 0 ? {} : _this$props$options;
        return react_1.default.createElement(Frame, {
          className: ['Summary__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Frame, {
          className: ['Summary__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, react_1.default.createElement(Frame, {
          className: ['Summary__specifications', classes === null || classes === void 0 ? void 0 : classes.specifications],
          style: styles === null || styles === void 0 ? void 0 : styles.specifications
        }, react_1.default.createElement(Text, {
          className: ['Summary__header', classes === null || classes === void 0 ? void 0 : classes.header],
          style: styles === null || styles === void 0 ? void 0 : styles.header
        }, "Base Specifications:"), react_1.default.createElement(List, {
          className: ['Summary__list', classes === null || classes === void 0 ? void 0 : classes.list, classes === null || classes === void 0 ? void 0 : classes.listSpecifications],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.list), styles === null || styles === void 0 ? void 0 : styles.listSpecifications)
        }, Object.keys(baseSpecifications).map(function (attribute) {
          var property = baseSpecifications[attribute];
          return react_1.default.createElement(ListItem, {
            className: ['Summary__list-item', classes === null || classes === void 0 ? void 0 : classes.listItem, classes === null || classes === void 0 ? void 0 : classes.listItemSpecifications],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.listItem), styles === null || styles === void 0 ? void 0 : styles.listItemSpecifications)
          }, react_1.default.createElement(Text, {
            className: ['Summary__list-item--cateogry', classes === null || classes === void 0 ? void 0 : classes.listItemCategory, classes === null || classes === void 0 ? void 0 : classes.listItemSpecificationsCategory],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.listItemCategory), styles === null || styles === void 0 ? void 0 : styles.listItemSpecificationsCategory)
          }, attribute), react_1.default.createElement(Text, {
            className: ['Summary__list-item--property', classes === null || classes === void 0 ? void 0 : classes.listItemProperty],
            style: styles === null || styles === void 0 ? void 0 : styles.listItemProperty
          }, property));
        }))), react_1.default.createElement(Frame, {
          className: ['Summary__options', classes === null || classes === void 0 ? void 0 : classes.options],
          style: styles === null || styles === void 0 ? void 0 : styles.options
        }, react_1.default.createElement(Text, {
          className: ['Summary__header', classes === null || classes === void 0 ? void 0 : classes.header],
          style: styles === null || styles === void 0 ? void 0 : styles.header
        }, "Options:"), react_1.default.createElement(List, {
          className: ['Summary__list', classes === null || classes === void 0 ? void 0 : classes.list, classes === null || classes === void 0 ? void 0 : classes.listOptions],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.list), styles === null || styles === void 0 ? void 0 : styles.listOptions)
        }, Object.keys(options).map(function (category) {
          var _a, _b, _c, _d;

          var property = options[category];
          return react_1.default.createElement(ListItem, {
            className: ['Summary__list-item', classes === null || classes === void 0 ? void 0 : classes.listItem, classes === null || classes === void 0 ? void 0 : classes.listItemOptions],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.listItem), styles === null || styles === void 0 ? void 0 : styles.listItemOptions)
          }, react_1.default.createElement(Text, {
            className: ['Summary__list-item--cateogry', classes === null || classes === void 0 ? void 0 : classes.listItemCategory],
            style: styles === null || styles === void 0 ? void 0 : styles.listItemCategory
          }, category), react_1.default.createElement(Frame, {
            className: ['Summary__row', classes === null || classes === void 0 ? void 0 : classes.row],
            style: styles === null || styles === void 0 ? void 0 : styles.row
          }, (((_a = property.display) === null || _a === void 0 ? void 0 : _a.hex) || ((_b = property.display) === null || _b === void 0 ? void 0 : _b.image)) && react_1.default.createElement(ColorSquare, {
            hex: (_c = property.display) === null || _c === void 0 ? void 0 : _c.hex,
            image: (_d = property.display) === null || _d === void 0 ? void 0 : _d.image,
            style: {
              square: style(theme).colorSquare,
              gradient: style(theme).colorSquareGradient
            }
          }), react_1.default.createElement(Text, null, property.name)));
        })))), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Summary = Summary;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api;
  var db = new BrightsmithDb(api);
  var configuration = db.getConfiguration();
  var model = db.getCurrentModel();
  var baseSpecifications = model.baseSpecifications;
  var options = {};

  if (configuration) {
    Object.keys(configuration).forEach(function (attributeId) {
      var propertyId = configuration[attributeId];
      var attribute = db.getAttribute(attributeId);

      if (attribute.categoryId) {
        var category = db.getCategory(attribute.categoryId);
        var property = db.getProperty(propertyId);
        options[category.name] = property;
      }
    });
  }

  return {
    baseSpecifications: baseSpecifications,
    options: options
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _a === void 0 ? void 0 : _a.container),
    colorSquare: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.border('1px solid #cdcdcd')), {
      height: 16,
      marginBottom: 8,
      marginRight: 8,
      marginTop: 4,
      width: 16
    }), (_b = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _b === void 0 ? void 0 : _b.colorSquare),
    colorSquareGradient: Object.assign({
      display: 'none'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _c === void 0 ? void 0 : _c.colorSquareGradient),
    header: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.borderBottom("1px solid ".concat((_d = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _d === void 0 ? void 0 : _d.primary))), {
      color: (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.secondary,
      fontSize: 18,
      fontWeight: '500',
      marginBottom: 5,
      padding: 5,
      paddingLeft: 0,
      textTransform: 'uppercase'
    }), (_f = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _f === void 0 ? void 0 : _f.header),
    inner: Object.assign({
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      width: '100%'
    }, (_g = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _g === void 0 ? void 0 : _g.inner),
    list: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_h = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _h === void 0 ? void 0 : _h.list),
    listItem: Object.assign(Object.assign({
      display: 'flex',
      flexDirection: 'column',
      fontSize: 16,
      lineHeight: '26px'
    }, StyleUtils_1.default.padding('7px 0')), (_j = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _j === void 0 ? void 0 : _j.listItem),
    listItemCategory: Object.assign({
      color: '#000',
      fontWeight: '500',
      marginRight: 7,
      textTransform: 'uppercase'
    }, (_k = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _k === void 0 ? void 0 : _k.listItemCategory),
    listItemSpecificationsCategory: Object.assign({}, (_l = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _l === void 0 ? void 0 : _l.listItemSpecificationsCategory),
    listItemProperty: Object.assign({}, (_m = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _m === void 0 ? void 0 : _m.listItemProperty),
    listItemOptions: Object.assign({}, (_o = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _o === void 0 ? void 0 : _o.listItemOptions),
    listItemSpecifications: Object.assign({}, (_p = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _p === void 0 ? void 0 : _p.listItemSpecifications),
    listOptions: Object.assign({}, (_q = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _q === void 0 ? void 0 : _q.listOptions),
    listSpecifications: Object.assign({}, (_r = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _r === void 0 ? void 0 : _r.listSpecifications),
    options: Object.assign({
      flex: 1
    }, (_s = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _s === void 0 ? void 0 : _s.options),
    row: Object.assign({
      display: 'flex',
      flexDirection: 'row'
    }, (_t = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _t === void 0 ? void 0 : _t.row),
    specifications: Object.assign({
      flex: 1
    }, (_u = theme === null || theme === void 0 ? void 0 : theme.Summary) === null || _u === void 0 ? void 0 : _u.specifications)
  };
};

exports.style = style;